var React = require('react');

function Orders (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"cart-r","d":"M2,2.25H5.334l.942,2.825H21.089L15.61,14.962H8.944L7.113,17.4a2.108,2.108,0,0,1,.181.383h8.245a2.119,2.119,0,1,1,0,1.412H7.294a2.118,2.118,0,1,1-1.27-2.7L7.8,14.128,4.316,3.662H2Zm7.1,11.3h5.678l3.914-7.062H6.746Zm8.436,4.237a.706.706,0,1,0,.706.706A.706.706,0,0,0,17.536,17.786Zm-12.947.706A.706.706,0,1,1,5.3,19.2.706.706,0,0,1,4.589,18.493Z","transform":"translate(-2 -2.25)","fill":"#b1b1b1","fillRule":"evenodd"}));
}

Orders.defaultProps = {"width":"19.089","height":"18.361","viewBox":"0 0 19.089 18.361"};

module.exports = Orders;

Orders.default = Orders;
